import React from 'react';

class Home extends React.Component {


    render() {

        return <iframe src="https://shivamd20.github.io/shankhacks/"
            style={{
                
                height : '90vh',
            
            position:'relative',
            width : '100%',
           }} frameborder="0" overflow="auto"
            allowfullscreen  >
            <p> <a target='_parent' href="https://shivamd20.github.io/shankhacks/">
                Learn more
  </a> </p>
        </iframe>
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.js